var $9c3b35ecd7c5e348$exports = {};
$9c3b35ecd7c5e348$exports = {
  "help": "Pal\u012Bdz\u012Bba",
  "info": "Inform\u0101cija"
};
export { $9c3b35ecd7c5e348$exports as default };